import { getEnumValues, isArray, isBoolean, isDiscriminatedUnion, isEnum, isIntNumber, isLiteral, isNumber, isObject, isObjectArray, isString, isStringArray, isStringFormat, isStringLongish, } from '../lib/walk-schema.js';
import { TextWidget } from './text.js';
import { TextareaWidget } from './textarea.js';
import { SecretWidget } from './secret.js';
import { NumberWidget } from './number.js';
import { DecimalWidget } from './decimal.js';
import { BooleanWidget } from './boolean.js';
import { RadioWidget } from './radio.js';
import { SelectWidget } from './select.js';
import { ChipInputWidget } from './chip-input.js';
import { MultiSelectWidget } from './multiselect.js';
import { RepeaterWidget } from './repeater.js';
import { FieldsetWidget } from './fieldset.js';
import { DiscriminatedWidget } from './discriminated.js';
import { JsonWidget } from './json.js';
import { HiddenWidget } from './hidden.js';
import { DateTimeWidget } from './datetime.js';
export const defaultWidgets = [
    {
        id: 'json',
        priority: 100,
        matches: (_s, m) => m.widget === 'json',
        component: JsonWidget,
    },
    {
        id: 'secret',
        priority: 95,
        matches: (_s, m) => m.secret === true,
        component: SecretWidget,
    },
    {
        id: 'textarea',
        priority: 90,
        matches: (s, m) => m.widget === 'textarea' || (isString(s) && isStringLongish(s, 80)),
        component: TextareaWidget,
    },
    {
        id: 'hidden',
        priority: 85,
        matches: (s) => isLiteral(s),
        component: HiddenWidget,
    },
    {
        id: 'discriminated',
        priority: 80,
        matches: (s) => isDiscriminatedUnion(s),
        component: DiscriminatedWidget,
    },
    {
        // Момент времени (ISO) по «стенным часам» пояса из meta.timeZone — только по явному meta.widget.
        id: 'datetime',
        priority: 75,
        matches: (s, m) => m.widget === 'datetime' && isString(s),
        component: DateTimeWidget,
    },
    {
        id: 'email',
        priority: 70,
        matches: (s) => isString(s) && isStringFormat(s, 'email'),
        component: TextWidget,
    },
    {
        id: 'url',
        priority: 70,
        matches: (s) => isString(s) && isStringFormat(s, 'url'),
        component: TextWidget,
    },
    {
        id: 'boolean',
        priority: 60,
        matches: (s) => isBoolean(s),
        component: BooleanWidget,
    },
    {
        // Дробное с запятой — только по явному meta.widget, обычные числа как были.
        id: 'decimal',
        priority: 56,
        matches: (s, m) => m.widget === 'decimal' && (isNumber(s) || isIntNumber(s)),
        component: DecimalWidget,
    },
    {
        id: 'number',
        priority: 55,
        matches: (s) => isNumber(s) || isIntNumber(s),
        component: NumberWidget,
    },
    {
        id: 'enum-radio',
        priority: 50,
        matches: (s, m) => {
            if (!isEnum(s))
                return false;
            const opts = m.options ?? getEnumValues(s).map((v) => ({ value: v, label: v }));
            return opts.length <= 4;
        },
        component: RadioWidget,
    },
    {
        id: 'enum-select',
        priority: 45,
        matches: (s) => isEnum(s),
        component: SelectWidget,
    },
    {
        id: 'multiselect',
        priority: 42,
        matches: (s, m) => m.widget === 'multiselect' && isStringArray(s),
        component: MultiSelectWidget,
    },
    {
        id: 'chip-input',
        priority: 40,
        matches: (s) => isStringArray(s),
        component: ChipInputWidget,
    },
    {
        id: 'repeater',
        priority: 35,
        matches: (s) => isObjectArray(s) || isArray(s),
        component: RepeaterWidget,
    },
    {
        id: 'fieldset',
        priority: 30,
        matches: (s) => isObject(s),
        component: FieldsetWidget,
    },
    {
        id: 'text',
        priority: 20,
        matches: (s) => isString(s),
        component: TextWidget,
    },
    {
        id: 'json-fallback',
        priority: 0,
        matches: () => true,
        component: JsonWidget,
    },
];
//# sourceMappingURL=registry.js.map